/**
 * Check view port width
 * @ignore
 * @param {Number} width
 * @return {boolean}
 */
export default function inViewPort(width) {
    let viewportWidth = 0;
    const setViewportWidth = () => {
        viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    };
    setViewportWidth();
    window.addEventListener('resize', function () {
        setViewportWidth();
    }, false);
    return viewportWidth >= width;
}
